import { Button } from "@/components/common/Button/Button"
import {
  ModalBase,
  ModalBaseProps,
} from "@/components/common/ModalBase/ModalBase"
import { Typography } from "@/components/common/Typography/Typography"
import { IconProps } from "@tabler/icons-react"

export interface ModalProps extends ModalBaseProps {
  ModalIcon?: React.ComponentType<IconProps>
  descriptionText: string
  primaryActionTitle: string
  primaryActionIcon?: React.ComponentType<IconProps>
  primaryActionIconPosition?: "left" | "right"
  secondaryActionTitle?: string
  onPrimaryAction: () => void
  onSecondaryAction: () => void
  modalTestId?: string
  primaryActionButtonTestId?: string
  secondaryActionButtonTestId?: string
  isPrimaryActionDisabled?: boolean
}

export const Modal: React.FC<ModalProps> = ({
  ModalIcon,
  descriptionText,
  primaryActionTitle,
  primaryActionIcon,
  primaryActionIconPosition = "right",
  secondaryActionTitle,
  onPrimaryAction,
  onSecondaryAction,
  onClose,
  showSidebarLeft,
  overshadowContentRight,
  modalTestId,
  primaryActionButtonTestId,
  secondaryActionButtonTestId,
  isPrimaryActionDisabled = false,
}) => {
  return (
    <ModalBase
      onClose={onClose}
      showSidebarLeft={showSidebarLeft}
      overshadowContentRight={overshadowContentRight}
      modalTestId={modalTestId}
    >
      <div className="flex min-h-full flex-col items-center justify-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full text-white">
          {ModalIcon && <ModalIcon size={40} stroke={1} />}
        </div>

        <Typography className="m-8 max-w-96 text-center" as="p" variant="textM">
          {descriptionText}
        </Typography>
        <div className="flex w-80 flex-col space-y-4">
          <Button
            variantColor="yellow"
            title={primaryActionTitle}
            label={primaryActionTitle}
            onClick={onPrimaryAction}
            IconLeft={
              primaryActionIconPosition === "left" ? primaryActionIcon : undefined
            }
            IconRight={
              primaryActionIconPosition === "right"
                ? primaryActionIcon
                : undefined
            }
            variantSize="medium"
            isFullWidth={true}
            dataTestId={primaryActionButtonTestId}
            isDisabled={isPrimaryActionDisabled}
          />
          {secondaryActionTitle && (
            <Button
              variantColor="dark"
              title={secondaryActionTitle}
              label={secondaryActionTitle}
              onClick={onSecondaryAction}
              variantSize="medium"
              isFullWidth={true}
              dataTestId={secondaryActionButtonTestId}
            />
          )}
        </div>
      </div>
    </ModalBase>
  )
}
